<template>
  <div>
    <input
      type="checkbox"
      id="unchecked"
      class="cbx hidden"
      v-model="checked"
    />
    <label for="unchecked" class="lbl"></label>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
  },
  data() {
    return {
      checked: this.value,
    };
  },
  watch: {
    checked(val) {
      this.$emit("input", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.lbl {
  position: relative;
  display: block;
  height: 20px;
  width: 44px;
  background: #898989;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.lbl:after {
  position: absolute;
  left: -2px;
  top: -3px;
  display: block;
  width: 26px;
  height: 26px;
  border-radius: 100px;
  background: #fff;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.05);
  content: "";
  transition: all 0.3s ease;
}
.lbl:active:after {
  transform: scale(1.15, 0.85);
}
.cbx:checked ~ label {
  background: var(--color-primary-light);
}
.cbx:checked ~ label:after {
  left: 20px;
  background: var(--color-primary);
}
.cbx:disabled ~ label {
  background: #d5d5d5;
  pointer-events: none;
}
.cbx:disabled ~ label:after {
  background: #bcbdbc;
}

.hidden {
  display: none;
}
</style>
